import type { QueryClient } from "@tanstack/react-query";
import type { PaginatedResultOfGetMakeupResponse } from "@/openapi/generated";
import type { GetMakeupResponse } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";

export function upsertMakeupSessionInQueryCache(
  queryClient: QueryClient,
  session: GetMakeupResponse,
): void {
  queryClient.setQueriesData<PaginatedResultOfGetMakeupResponse>(
    { queryKey: [QueryKeys.MakeupSessions] },
    (old) => {
      if (!old?.items) return old;
      const index = old.items.findIndex((item) => item.id === session.id);
      if (index >= 0) {
        const items = [...old.items];
        items[index] = session;
        return { ...old, items };
      }
      return { ...old, items: [session, ...old.items] };
    },
  );
}
